import { render, staticRenderFns } from "./NotificationsSettings.vue?vue&type=template&id=68c3184a&"
import script from "./NotificationsSettings.vue?vue&type=script&lang=js&"
export * from "./NotificationsSettings.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VContainer,VForm,VSwitch})
